(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDetailController', PhoneCallStatusDetailController);

    /* Added UIFormAccess
    PhoneCallStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallStatus) {
    */
    PhoneCallStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallStatus', 'UIFormAccess'];

    function PhoneCallStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallStatus, UIFormAccess) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallStatusUpdate', function(event, result) {
            vm.phoneCallStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
